<template>
  <div class="content-wrapper">
    <div class="content-header row"></div>
    <div class="content-overlay"></div>
    <div class="content-body">
      <!-- Stats Vertical Card -->
      <div class="row">
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ myClientTickets }}</h2>
              <p class="card-text mb-0">Tickets dos meus clientes</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ myTickets }}</h2>
              <p class="card-text mb-0">Tickets na minha pauta</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ myTicketsToday }}</h2>
              <p class="card-text mb-0">Minha pauta para hoje</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ mySectorTicketsTotal }}</h2>
              <p class="card-text mb-0">Tickets do meu setor</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ mySectorTicketsTodayTotal }}</h2>
              <p class="card-text mb-0">Tickets do setor para hoje</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
        <div class="col-xl-2 col-md-4 col-sm-6">
          <div class="card text-center">
            <div class="card-body">
              <h2 class="font-weight-bolder">{{ mySectorTicketsLateTotal }}</h2>
              <p class="card-text mb-0">Tickets do setor atrasados</p>
              <small>(Somente Abertos)</small>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-md-12 col-12">
          <div class="card card-statistics">
            <div class="card-header pb-0">
              <h4 class="card-title">Estatísticas por Equipe:</h4>
              <div class="d-flex align-items-center"></div>
            </div>
            <div class="card-body statistics-body">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="font-weight-bolder">&nbsp;</th>
                      <th class="font-weight-bolder" v-for="(name, key) in teams" :key="key">
                        <a :href="'/#/tickets/' + key">{{ name }}</a>
                      </th>
                      <th class="font-weight-bolder">Totais</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, key) in result" :key="key">
                      <td>{{ key }}</td>
                      <td class="text-nowrap" v-for="(tvalue, tkey) in teams" :key="tkey">
                        <div class="d-flex">
                          <span class="font-weight-bolder mb-25">{{value[tkey]}}</span>
                          <span class="font-small-2 text-muted" v-if="totais[key] === 0">
                            &nbsp;(0 %)
                          </span>
                          <span class="font-small-2 text-muted" v-else>
                            &nbsp;({{ ((value[tkey] * 100) / totais[key]).toFixed(1) + "%" }})
                          </span>
                        </div>
                      </td>
                      <td>
                        <div class="d-flex">
                          <span class="font-weight-bolder mb-25">{{ totais[key] }}</span>
                          <span class="font-small-2 text-muted">&nbsp;(100%)</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-responsive">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-body" v-if="showReports">
      <customer-reports :show-customer-filter="isAdmin"></customer-reports>
    </div>
  </div>
</template>
<script>
import { H } from 'hennig-common'
import CustomerReports from '../components/CustomerReports'

export default {
  name: 'DashboardNew',
  components: {
    'customer-reports': CustomerReports,
  },
  data () {
    return {
      userName: '',
      teams: [],
      result: [],
      totais: [],
      myClientTickets: 0,
      myTickets: 0,
      myTicketsToday: 0,
      mySectorTicketsTotal: 0,
      mySectorTicketsTodayTotal: 0,
      mySectorTicketsLateTotal: 0,
      isAdmin: true,
      showReports: false
    }
  },
  mounted () {
    let self = this
    H.rpc('Dashboard', 'HeaderData', [], (r) => {
      if (r) {
        this.myTickets = r.myTickets || 0
        this.myTicketsToday = r.myTicketsToday || 0
        this.myTicketsLate = r.myTicketsLate || 0
        this.myClientTickets = r.myClientTickets || 0
        this.mySectorTickets = r.mySectorTickets || 0
        this.mySectorTicketsLate = r.mySectorTicketsLate || 0
        this.mySectorTicketsToday = r.mySectorTicketsToday || 0

        this.mySectorTicketsTotal = r.mySectorTicketsTotal || 0
        this.mySectorTicketsLateTotal = r.mySectorTicketsLateTotal || 0
        this.mySectorTicketsTodayTotal = r.mySectorTicketsTodayTotal || 0
      }
    })

    H.rpc('DashboardNew', 'myTicketsData', [], (r) => {
      if (r) {
        this.teams = r.teams
        this.result = r.result
        this.totais = r.totais
      }
    })

    // Carrega os relatórios após as estatísticas principais para melhorar a percepção de performance
    setTimeout(() => {
      this.showReports = true
    }, 800)
  },
}
</script>

<style scoped>
</style>


